"use client";

import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui";
import { SHOP_SORTS, type ShopSort, parseShopSort } from "@/lib/shop-catalog-view";
import { cx } from "@/lib/tailwind-utils";
interface ShopSortSelectProps {
  value: ShopSort;
  onChange: (sort: ShopSort) => void;
  className?: string;
}
export function ShopSortSelect(t0) {
  const $ = _c(18);
  const {
    value,
    onChange,
    className
  } = t0;
  const id = `${useId()}-sort`;
  let t1;
  if ($[0] !== className) {
    t1 = cx("w-full sm:w-56", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id) {
    t2 = <Label htmlFor={id}>Sort by</Label>;
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onChange) {
    t3 = next => onChange(parseShopSort(next));
    $[4] = onChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SelectValue placeholder="Featured" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== id) {
    t5 = <SelectTrigger id={id} data-testid="shop-sort">{t4}</SelectTrigger>;
    $[7] = id;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SelectContent>{SHOP_SORTS.map(_temp)}</SelectContent>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== value) {
    t7 = <Select value={value} onValueChange={t3}>{t5}{t6}</Select>;
    $[10] = t3;
    $[11] = t5;
    $[12] = value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t7) {
    t8 = <div className={t1}>{t2}{t7}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp(sort) {
  return <SelectItem key={sort.value} value={sort.value}>{sort.label}</SelectItem>;
}